import React from 'react';
import { useSelector} from 'react-redux';
function Sidebar(){
    var userReduxData = useSelector(state => state.auth);
    userReduxData =  userReduxData && userReduxData.user_info ? JSON.parse(userReduxData.user_info) : null;
    const userRoleIds = userReduxData ? userReduxData.role_ids : [];
    return(
        <nav className="sidebar sidebar-offcanvas" id="sidebar">
          {(localStorage.getItem("token") && userReduxData) && (
          <ul className="nav">
            {/* <li className="nav-item nav-profile">
              <a href="#" className="nav-link">
                <div className="nav-profile-image">
                  <img src="assets/images/faces/face1.jpg" alt="profile" />
                  <span className="login-status online"></span>
                </div>
                <div className="nav-profile-text d-flex flex-column">
                  <span className="font-weight-bold mb-2">Admin IFSPD</span>
                  <span className="text-secondary text-small">Admin</span>
                </div>
                <i className="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
              </a>
            </li> */}
			      <li className="nav-item">
              <a className="nav-link" href="/">
                <span className="menu-title">Dashboard</span>
                <i className="mdi mdi-chart-line menu-icon"></i>
              </a>
            </li>
            {/* Subscription */}
            {(userRoleIds.includes(2)
              || userRoleIds.includes(7)
            ) && (
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="collapse" href="#manage-subscription" aria-expanded="false" aria-controls="manage-subscription">
                  <span className="menu-title">Manage Subscriptions</span>
                  <i className="menu-arrow"></i>
                  <i className="mdi mdi-calendar-clock menu-icon"></i>
                </a>
                <div className="collapse" id="manage-subscription">
                  <ul className="nav flex-column sub-menu">
                    <li className="nav-item"> <a className="nav-link" href="/manage-enrollments">Validity Extension</a></li>
                  </ul>
                </div>
              </li>
            )}
            {(userRoleIds.includes(2)
              || userRoleIds.includes(5)
              || userRoleIds.includes(3)
              || userRoleIds.includes(7)
            ) && (
              <>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="collapse" href="#manage-student" aria-expanded="false" aria-controls="manage-student">
                  <span className="menu-title">Manage Students</span>
                  <i className="menu-arrow"></i>
                  <i className="mdi mdi-account-group menu-icon"></i>
                </a>
                <div className="collapse" id="manage-student">
                  <ul className="nav flex-column sub-menu">
                    <li className="nav-item"> <a className="nav-link" href="/manage-students">Students</a></li>
                    <li className="nav-item"> <a className="nav-link" href="/analytics-port">Port Analytics</a></li>
                    {(userRoleIds.includes(2) 
                      || userRoleIds.includes(7)
                    ) && (
                      <li className="nav-item"> <a className="nav-link" href="/pinned-students">Top Deck</a></li>
                    )}
                  </ul>
                </div>
              </li>
              </>
            )}
            
            {/* Glosco */}
            {/* 2 => Super Admin, 3=> Teacher, 4=> Counsellor, 5=>Principal, 7=>Admin,   */}
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="collapse" href="#manage-glosco" aria-expanded="false" aria-controls="manage-glosco">
                <span className="menu-title">Manage GLOSCO</span>
                <i className="menu-arrow"></i>
                <i className="mdi mdi-account-group menu-icon"></i>
              </a>
              <div className="collapse" id="manage-glosco">
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <a className="nav-link" href="/manage-glosco-cohort">Manage Cohorts</a></li>
                  {(userRoleIds.includes(2)
                    || userRoleIds.includes(4)
                    || userRoleIds.includes(5)
                    || userRoleIds.includes(7)
                  ) && (
                    <li className="nav-item"> <a className="nav-link" href="/manage-glosco-requests">Approval Requests</a></li>
                  )}
                  {(userRoleIds.includes(2)
                    || userRoleIds.includes(7)
                  ) && (
                    <li className="nav-item"> <a className="nav-link" href="/manage-global-conferences-sessions">Global Conferences Sessions</a></li>
                  )}
                  {(userRoleIds.includes(2)
                    || userRoleIds.includes(4)
                    || userRoleIds.includes(5)
                    || userRoleIds.includes(7)
                  ) && (
                    <>
                    <li className="nav-item"> <a className="nav-link" href="/manage-glosco-grip-sessions">GLOSCO & GRIP Sessions</a></li>
                    <li className="nav-item"> <a className="nav-link" href="/manage-glosco-level">Students Level/Year</a></li>
                    </>
                  )}
                </ul>
              </div>
            </li>
            {(userRoleIds.includes(2)
              || userRoleIds.includes(7)
            ) && (
              <li className="nav-item">
                <a className="nav-link" href="/manage-nominations/list">
                  <span className="menu-title">Manage Nominations</span>
                  <i className="mdi mdi-file-document menu-icon"></i>
                </a>
              </li>
            )}
            {/* S Admin */}
            {userRoleIds.includes(2) && (
              <>
              <li className="nav-item">
                <a className="nav-link" href="/manage-opportunities">
                  <span className="menu-title">Manage Opportunities</span>
                  <i className="mdi mdi-briefcase menu-icon"></i>
                </a>
              </li>
              </>
            )}

            {userRoleIds.includes(2) && (
              <>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="collapse" href="#manage-fellow" aria-expanded="false" aria-controls="manage-fellow">
                  <span className="menu-title">Manage Fellows</span>
                  <i className="menu-arrow"></i>
                  <i className="mdi mdi-contacts menu-icon"></i>
                </a>
                <div className="collapse" id="manage-fellow">
                  <ul className="nav flex-column sub-menu">
                    <li className="nav-item"> <a className="nav-link" href="/manage-fellows">Fellows List</a></li>
                    <li className="nav-item"> <a className="nav-link" href="/manage-fellows">Approve Fellows</a></li>
                  </ul>
                </div>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="collapse" href="#manage-affiliate" aria-expanded="false" aria-controls="manage-affiliate">
                  <span className="menu-title">Manage Affiliates</span>
                  <i className="menu-arrow"></i>
                  <i className="mdi mdi-contacts menu-icon"></i>
                </a>
                <div className="collapse" id="manage-affiliate">
                  <ul className="nav flex-column sub-menu">
                    {/* <li className="nav-item"> <a className="nav-link" href="/manage-affiliates/list">Affiliates List</a></li> */}
                    <li className="nav-item"> <a className="nav-link" href="/manage-affiliates/request">Approve Affiliates</a></li>
                    <li className="nav-item"> <a className="nav-link" href="/manage-affiliates/settings">Commission Settings</a></li>
                  </ul>
                </div>
              </li>
              </>
            )}
            {/* Super Admin/Principal/Admin */}
            {(userRoleIds.includes(2)
              || userRoleIds.includes(5)
              || userRoleIds.includes(7)
            ) && (
            <li className="nav-item">
              <a className="nav-link" href="/manage-admins">
                <span className="menu-title">Manage Admins</span>
                <i className="mdi mdi-account-tie menu-icon"></i>
              </a>
            </li>
            )}
            {/* Logout */}
            <li className="nav-item">
              <a className="nav-link" href="/logout">
                <span className="menu-title">Logout</span>
                <i className="mdi mdi-power menu-icon"></i>
              </a>
            </li>
			{/* <li className="nav-item">
              <a className="nav-link" href="/">
                <span className="menu-title">Manage Fellows</span>
                <i className="mdi mdi-contacts menu-icon"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/">
                <span className="menu-title">Dashboard</span>
                <i className="mdi mdi-home menu-icon"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="collapse" href="#ui-basic" aria-expanded="false" aria-controls="ui-basic">
                <span className="menu-title">Basic UI Elements</span>
                <i className="menu-arrow"></i>
                <i className="mdi mdi-crosshairs-gps menu-icon"></i>
              </a>
              <div className="collapse" id="ui-basic">
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <a className="nav-link" href="pages/ui-features/buttons.html">Buttons</a></li>
                  <li className="nav-item"> <a className="nav-link" href="pages/ui-features/typography.html">Typography</a></li>
                </ul>
              </div>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="pages/icons/mdi.html">
                <span className="menu-title">Icons</span>
                <i className="mdi mdi-contacts menu-icon"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="pages/forms/basic_elements.html">
                <span className="menu-title">Forms</span>
                <i className="mdi mdi-format-list-bulleted menu-icon"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="pages/charts/chartjs.html">
                <span className="menu-title">Charts</span>
                <i className="mdi mdi-chart-bar menu-icon"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="pages/tables/basic-table.html">
                <span className="menu-title">Tables</span>
                <i className="mdi mdi-table-large menu-icon"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="collapse" href="#general-pages" aria-expanded="false" aria-controls="general-pages">
                <span className="menu-title">Sample Pages</span>
                <i className="menu-arrow"></i>
                <i className="mdi mdi-medical-bag menu-icon"></i>
              </a>
              <div className="collapse" id="general-pages">
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <a className="nav-link" href="pages/samples/blank-page.html"> Blank Page </a></li>
                  <li className="nav-item"> <a className="nav-link" href="pages/samples/login.html"> Login </a></li>
                  <li className="nav-item"> <a className="nav-link" href="pages/samples/register.html"> Register </a></li>
                  <li className="nav-item"> <a className="nav-link" href="pages/samples/error-404.html"> 404 </a></li>
                  <li className="nav-item"> <a className="nav-link" href="pages/samples/error-500.html"> 500 </a></li>
                </ul>
              </div>
            </li>
            <li className="nav-item sidebar-actions">
              <span className="nav-link">
                <div className="border-bottom">
                  <h6 className="font-weight-normal mb-3">Projects</h6>
                </div>
                <button className="btn btn-block btn-lg btn-gradient-primary mt-4">+ Add a project</button>
                <div className="mt-4">
                  <div className="border-bottom">
                    <p className="text-secondary">Categories</p>
                  </div>
                  <ul className="gradient-bullet-list mt-4">
                    <li>Free</li>
                    <li>Pro</li>
                  </ul>
                </div>
              </span>
            </li> */}
          </ul>
          )}
        </nav>
    )
}

export default Sidebar;